import { render } from "./BaseScanner.vue?vue&type=template&id=7ca6280c"
import script from "./BaseScanner.vue?vue&type=script&lang=js"
export * from "./BaseScanner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__